<template>
  <div class="flex items-center space-x-1">
<!--    &lt;!&ndash; Notifications &ndash;&gt;-->
    <NotificationBadge />

    <!-- Menu utilisateur -->
    <UserDropdown :user="user" />
  </div>
</template>

<script setup>
defineProps({
  user: Object
})
</script>